import { schema } from 'normalizr'

export const category = new schema.Entity('categories', {}, { idAttribute: 'remoteId' })
export const arrayOfCategories = new schema.Array(category)



// WEBPACK FOOTER //
// ./src/adapters/categorySchema.js